import { useState } from 'react';
import EntryEditModal from './EntryEditModal.jsx';
import EntryDetailModal from './EntryDetailModal.jsx';

export default function TimesheetTable({ entries, showCrew, isAdmin }) {
  // Single piece of state: the row currently open. `mode` toggles between
  // detail (read-only popover) and edit (admin-only form).
  const [open, setOpen] = useState(null); // { entry, mode: 'detail' | 'edit' }

  if (!entries?.length) return <div className="loading">No entries in range.</div>;

  return (
    <>
      <table className="tbl">
        <thead>
          <tr>
            <th>Day</th>
            {showCrew && <th>Crew</th>}
            <th>Job</th>
            <th>In</th>
            <th>Out</th>
            <th className="num">Hrs</th>
            <th className="col-meta">Src</th>
          </tr>
        </thead>
        <tbody>
          {entries.map(e => (
            <EntryRow key={e.id} e={e}
              showCrew={showCrew}
              onOpen={() => setOpen({ entry: e, mode: 'detail' })} />
          ))}
        </tbody>
      </table>
      {open?.mode === 'detail' && (
        <EntryDetailModal
          entry={open.entry}
          isAdmin={isAdmin}
          onEdit={() => setOpen({ entry: open.entry, mode: 'edit' })}
          onClose={() => setOpen(null)}
        />
      )}
      {open?.mode === 'edit' && isAdmin && (
        <EntryEditModal entry={open.entry} onClose={() => setOpen(null)} />
      )}
    </>
  );
}

function EntryRow({ e, showCrew, onOpen }) {
  const start = new Date(e.clock_in_at);
  const end = e.clock_out_at ? new Date(e.clock_out_at) : null;
  const hrs = end ? (end - start) / 3_600_000 : (Date.now() - start) / 3_600_000;
  return (
    <tr className="tbl-row-clickable" onClick={onOpen}>
      <td>{start.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' })}</td>
      {showCrew && <td>{e.user_name}</td>}
      <td>{e.job_name || <span style={{ color: 'var(--text-muted)' }}>—</span>}</td>
      <td>{start.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</td>
      <td>
        {end
          ? end.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
          : <span className="badge orange">open</span>}
      </td>
      <td className="num">{hrs.toFixed(2)}</td>
      <td className="col-meta"><span className="badge">{e.source_in}</span></td>
    </tr>
  );
}
